<template>
    <v-container v-if="getLanguageList" class="pa-2" fluid grid-list-sm >   
       <div v-if="needInit">{{initData()}}</div>  

       <v-layout row wrap>
            <v-flex xs4> <v-card outlined >  
                <v-card-text>
                    <language-list v-bind:ltype="1"></language-list>                
                    <a-chapter v-bind:ltype="1"></a-chapter>
                </v-card-text>
            </v-card>  </v-flex>
            <v-flex xs4> <v-card outlined >  
                <v-card-text> 
                    <language-list v-bind:ltype="2"></language-list>
                    <a-chapter v-bind:ltype="2"></a-chapter>
                </v-card-text>
            </v-card>  </v-flex>
            <v-flex xs4>                 
                <v-card>
                    <v-card-title class="layout justify-center">Chapter image:</v-card-title>
                    <v-card-text class="layout justify-center">
                        <v-layout row wrap>
                            <v-flex xs6> 
                                <v-img
                                    v-if="imageURL" 
                                    :src="imageURL"
                                    aspect-ratio="1"
                                    class="grey lighten-2"
                                    max-width="100"
                                    max-height="100" > 
                                </v-img>
                                <input type="file"
                                    accept="image/*.svg" 
                                    ref="fileInput"
                                    style="display:none"
                                    @change="onFilePicked"
                                    >
                            </v-flex>
                            <v-flex xs6> 
                                <v-img
                                    v-if="imageURL2" 
                                    :src="imageURL2"
                                    aspect-ratio="1"
                                    class="grey lighten-2"
                                    max-width="100"
                                    max-height="100" > 
                                </v-img>
                                <input type="file"
                                    accept="image/*.png" 
                                    ref="fileInput2"
                                    style="display:none"
                                    @change="onFilePicked2"
                                    >
                            </v-flex>
                            <v-flex xs6> 
                                <v-btn raised class="primary" @click="onPickFile">Upload image (svg)</v-btn>
                            </v-flex>
                            <v-flex xs6> 
                                <v-btn raised class="primary" @click="onPickFile2">Upload image (png)</v-btn>
                            </v-flex>
                        </v-layout>
                    </v-card-text>       
                </v-card>
            </v-flex>   
            <v-flex xs12>  
                <v-card outlined>
                    <v-card-title>
                        <v-flex xs4>
                            <v-combobox
                                v-model="chapter_type_text"
                                :items="types_list"
                                label="Select type"
                                @change="changeType()"
                            ></v-combobox>
                        </v-flex>
                    </v-card-title>
                    <v-card-text v-if="chapter_type == 2">
                        <v-layout row wrap>
                            <v-flex xs3>
                                <v-text-field label="Time limit (in seconds):" 
                                    style="margin:10px"
                                    v-model="time_limit"></v-text-field>
                            </v-flex>
                            <v-flex xs3>
                                <v-text-field label="Competition key:" 
                                    style="margin:10px"
                                    v-model="competition_key"></v-text-field>
                            </v-flex>
                            <v-flex xs6></v-flex>
                        </v-layout>
                        <v-layout row wrap>
                            <v-flex xs12>
                            <v-card>
                                <v-card-title>
                                    Test will be available:
                                </v-card-title>
                                <v-card-text>
                                    <v-layout row wrap>
                                        <v-flex xs2>
                                            <v-checkbox
                                            v-model="startOpen"
                                            label="From"
                                            ></v-checkbox>  
                                        </v-flex>
                                        <v-flex xs10 v-if="startOpen">
                                            <v-layout row wrap>
                                                <v-flex xs4>
                                                    <br>
                                                    <h3 @click="picker_pos = 1" style="text-align: center; border-style: solid; border-width: thin;">
                                                        {{my_date1}} 
                                                    </h3>
                                                    <v-date-picker v-if="picker_pos == 1" @change="picker_pos = -1" no-title v-model='my_date1'></v-date-picker>                               
                                                </v-flex>
                                                <v-flex xs3>   
                                                    <br>
                                                    <h3 @click="picker_pos = 2"  style="text-align: center; border-style: solid; border-width: thin;">
                                                        {{my_time1}} 
                                                    </h3>
                                                    <v-time-picker v-if="picker_pos == 2" @change="picker_pos = -1" format="24hr" no-title v-model='my_time1'></v-time-picker>                               
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row wrap>
                                        <v-flex xs2>
                                            <v-checkbox
                                            v-model="endOpen"
                                            label="To"
                                            ></v-checkbox>  
                                        </v-flex>
                                        <v-flex xs10 v-if="endOpen">
                                            <v-layout row wrap>
                                                <v-flex xs4>
                                                    <br>
                                                    <h3 @click="picker_pos = 3" style="text-align: center; border-style: solid; border-width: thin;">
                                                        {{my_date2}} 
                                                    </h3>
                                                    <v-date-picker  v-if="picker_pos == 3" @change="picker_pos = -1" no-title v-model='my_date2'></v-date-picker>                               
                                                </v-flex>
                                                <v-flex xs3>   
                                                    <br>
                                                    <h3 @click="picker_pos = 4" style="text-align: center; border-style: solid; border-width: thin;">
                                                        {{my_time2}} 
                                                    </h3>
                                                    <v-time-picker v-if="picker_pos == 4" @change="picker_pos = -1" format="24hr" no-title v-model='my_time2'></v-time-picker>                               
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                    </v-layout>
                                </v-card-text>
                            </v-card>
                            </v-flex>
                            <v-flex xs12>
                                <v-card>
                                <v-card-title>
                                    Test results will be available:
                                </v-card-title>
                                <v-card-text>
                                    <v-layout row wrap>
                                        <v-flex xs2>
                                            <v-checkbox
                                            v-model="startResult"
                                            label="From"
                                            ></v-checkbox>  
                                        </v-flex>
                                        <v-flex xs10 v-if="startResult">
                                            <v-layout row wrap>
                                                <v-flex xs4>
                                                    <br>
                                                    <h3 @click="picker_pos = 5" style="text-align: center; border-style: solid; border-width: thin;">
                                                        {{my_date3}} 
                                                    </h3>
                                                    <v-date-picker v-if="picker_pos == 5" @change="picker_pos = -1" no-title v-model='my_date3'></v-date-picker>                               
                                                </v-flex>
                                                <v-flex xs3>   
                                                    <br>
                                                    <h3 @click="picker_pos = 6"  style="text-align: center; border-style: solid; border-width: thin;">
                                                        {{my_time3}} 
                                                    </h3>
                                                    <v-time-picker v-if="picker_pos == 6" @change="picker_pos = -1" format="24hr" no-title v-model='my_time3'></v-time-picker>                               
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row wrap>
                                        <v-flex xs2>
                                            <v-checkbox
                                            v-model="endResult"
                                            label="To"
                                            ></v-checkbox>  
                                        </v-flex>
                                        <v-flex xs10 v-if="endResult">
                                            <v-layout row wrap>
                                                <v-flex xs4>
                                                    <br>
                                                    <h3 @click="picker_pos = 7" style="text-align: center; border-style: solid; border-width: thin;">
                                                        {{my_date4}} 
                                                    </h3>
                                                    <v-date-picker  v-if="picker_pos == 7" @change="picker_pos = -1" no-title v-model='my_date4'></v-date-picker>                               
                                                </v-flex>
                                                <v-flex xs3>   
                                                    <br>
                                                    <h3 @click="picker_pos = 8"  style="text-align: center; border-style: solid; border-width: thin;">
                                                        {{my_time4}} 
                                                    </h3>
                                                    <v-time-picker v-if="picker_pos == 8" @change="picker_pos = -1" format="24hr" no-title v-model='my_time4'></v-time-picker>                               
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                    </v-layout>
                                </v-card-text>
                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-flex>                  
                 
            <v-flex xs12>
                <v-card outlined >
                    <p></p>
                    <p v-if="getRefresh1 || getRefresh2">Preparing...</p>
                    <p v-if="getPreparedforSave && runSaving">{{saveData()}}</p>                    
                    <v-layout align-end justify-space-between row fill-height>
                        <v-flex xs4>
                            <p>Course:
                                <v-menu v-if="courseList.length > 0" transition="slide-y-transition" bottom right>
                                    <template v-slot:activator="{ on }">
                                        <v-btn large class="my-3" color="primary" v-on="on">
                                            {{ courseList[courseIndex].name}}
                                        </v-btn>
                                    </template>
                                    <v-list>
                                        <v-list-item
                                            v-for="(item, index) in courseList"
                                            :key="index"
                                            @click="courseIndex = index; courseID = item.id;"
                                        >
                                        <v-list-item-title>{{ item.name }}</v-list-item-title>
                                        </v-list-item>
                                    </v-list>  
                                </v-menu>
                            </p>
                        </v-flex>
                            <v-flex xs6>
                                <v-card outlined>
                                    <v-btn @click="saveAndClose">Save and close</v-btn>
                                    <v-btn @click="closeForm">Close without saving</v-btn>                    
                                </v-card>
                            </v-flex>
                    </v-layout>
                    <p></p>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import AChapter from '../AChapter.vue'
import LanguageList from '../LanguageList.vue'
import {mapGetters} from 'vuex'
import axios from '../../../axios-auth.js'

export default {
    data() {
        return {    
             runSaving: false,
             closeAfterSaving: false,
             contentUni: null,
             needInit : true,
             imageURL: '',
             image: null,
             imageURL2: '',
             image2: null,
             courseIndex : 0,
             courseID : 0,
             areaID: 0,
             myOrder: 0,
             courseList: [],
             chapter_type: 0,
             chapter_type_text: '',
             types_list: ['chapter', 'exercise', 'competition'],
             time_limit: 3600,
             competition_key: '',
             picker_pos: -1,
             my_date1: '2020-10-10',
             my_date2: '2020-10-10',
             my_time1: '00:00',
             my_time2: '00:00',
             my_date3: '2020-10-10',
             my_date4: '2020-10-10',
             my_time3: '00:00',
             my_time4: '00:00',
             startOpen : false,
             endOpen : false,
             startResult : false,
             endResult : false
            }
    },
    computed: 
        mapGetters([
                        'getRefresh1',
                        'getRefresh2',
                        'getAllContentUni',
                        'getLanguagePrimary',
                        'getLanguageSecondary',
                        'getPreparedforSave',
                        'getLanguageList',
                        'getAxiosConfig'
                    ])
    ,
    components: {
        AChapter,
        LanguageList
    },
    methods : {
        onPickFile() {
            this.$refs.fileInput.click()
        },
        onPickFile2() {
            this.$refs.fileInput2.click()
        },
        onFilePicked(event) {
            const files = event.target.files
            let filename = files[0].name
            if (filename.lastIndexOf('.svg') <=0 ) {
                return alert('Please upload a valid file')
            }
            const fileReader = new FileReader()
            fileReader.addEventListener('load', () =>  {
                    this.imageURL = fileReader.result
                }
            )
            fileReader.readAsDataURL(files[0])
            this.image = files[0]
        },
        onFilePicked2(event) {
            const files = event.target.files
            let filename = files[0].name
            if (filename.lastIndexOf('.png') <=0 ) {
                return alert('Please upload a valid file')
            }
            const fileReader = new FileReader()
            fileReader.addEventListener('load', () =>  {
                    this.imageURL2 = fileReader.result
                }
            )
            fileReader.readAsDataURL(files[0])
            this.image2 = files[0]
        },
        prepareDataforSave() {
            this.$store.commit('setFeedback', null)

            //// xxxxx check data - are there some data to fill?

            this.runSaving = true
            // saved data with temporary lang - set it to main lang
            this.$store.commit('setLangPrimaryTmp',this.getLanguagePrimary)
            this.$store.commit('setLangSecondaryTmp',this.getLanguageSecondary)

            this.$store.commit('setPreparedforSave',false)
            // send notification for save to store
            this.$store.commit('setRefresh1',true)
            this.$store.commit('setRefresh2',true)
        },
        saveData() {
            this.runSaving = false
            // prepare data for json
            const data = this.getAllContentUni

            if (isNaN(this.time_limit)) {
                this.$store.commit('setFeedback', 'Invalid number in time limit field')
                return
            }

            this.contentUni = {
                chapter_id : this.myID,
                course_id: this.courseID,
                icon: this.imageURL,
                icon2: this.imageURL2,
                chapter_order: this.myOrder,
                chapter_type: this.chapter_type,
                comp_key: this.competition_key,
                time_limit: this.time_limit,
                check_OB: this.startOpen,
                check_OE: this.endOpen,
                check_RB: this.startResult,
                check_RE: this.endResult,
                open_begin: this.my_date1 + ' ' + this.my_time1 + ":00",
//                open_begin: new Date(this.my_date1.substring(0,4), this.my_date1.substring(5,7), this.my_date1.substring(8), this.my_time1.substring(0,2), this.my_time1.substring(3), 0, 0).toISOString(),
                open_end: this.my_date2 + ' ' + this.my_time2 + ":00",
                results_begin: this.my_date3+' '+ this.my_time3+":00",
                results_end: this.my_date4+' '+ this.my_time4+":00",
                content_list: []
            }
            /* eslint-disable no-console */
            // console.log(this.contentUni)

            for(var key in data) {
                this.contentUni.content_list.push( {
                    lang_id : key.replace('l',''),
                    content :  data[key]
                })
            }
            /* eslint-disable no-console */
            // console.log(this.contentUni)

            // axios
            axios.post('/create-edit-chapter-all-lang', this.contentUni, this.getAxiosConfig)
            .then(() => {    
                if (this.closeAfterSaving) this.closeForm()
            })
            .catch(error => {
                this.$store.commit('setFeedback', error)
            })
        
        },
        
        saveAndClose() {
            this.closeAfterSaving = true
            this.prepareDataforSave()            
        },
        closeForm() {
            this.$router.push({name:'course_admin_content', params: {id: this.courseID}})   
        },
        initData() {            
            this.needInit = false
            this.$store.commit('setFeedback', null)
            // saved data with temporary lang - set it to main lang
            this.$store.commit('setLangPrimaryTmp',this.getLanguagePrimary)
            this.$store.commit('setLangSecondaryTmp',this.getLanguageSecondary)

            this.myID = this.$route.params.id
            this.courseID = this.$route.params.course_id
            this.areaID = this.$route.params.area_id
            this.chapter_type = this.$route.params.ch_type
            this.chapter_type_text = this.types_list[this.chapter_type]
            this.my_date1 = new Date().toISOString().slice(0,10); 
            this.my_date2 = this.my_date1
            this.my_date3 = this.my_date1
            this.my_date4 = this.my_date1

            if (this.myID == '0') {
                this.$store.commit('prepareUni','default')
            } else {
                // load existing data
                axios.get('/get-chapter-in-all-lang/' + this.$route.params.id, this.$store.getters.getAxiosConfig )
                .then(res => {
                    const data = {                        
                        cType: 'default',
                        content_list : res.data.list
                    }

                    this.$store.dispatch('setFullContentUni', data)
                    this.myOrder = res.data.chapter_order 
                    this.imageURL = res.data.chapter_icon
                    this.imageURL2 = res.data.chapter_icon2
                    this.chapter_type = res.data.chapter_type
                    this.chapter_type_text = this.types_list[this.chapter_type]
                    this.competition_key = res.data.comp_key
                    this.time_limit = res.data.time_limit
                    this.my_date1 = res.data.open_begin.substring(0,10)
                    this.my_time1 = res.data.open_begin.substring(11,16)
                    this.my_date2 = res.data.open_end.substring(0,10)
                    this.my_time2 = res.data.open_end.substring(11,16)
                    this.my_date3 = res.data.results_begin.substring(0,10)
                    this.my_time3 = res.data.results_begin.substring(11,16)
                    this.my_date4 =res.data.results_end.substring(0,10)
                    this.my_time4 = res.data.results_end.substring(11,16)
                    this.startOpen = res.data.check_OB
                    this.endOpen = res.data.check_OE
                    this.startResult = res.data.check_RB
                    this.endResult = res.data.check_RE
                })   
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })
            }

            axios.get('/area-all-courses/' + this.areaID, this.$store.getters.getAxiosConfig )
                .then(res => {
                    this.courseIndex = 0
                    this.courseList = []
                    for(let i = 0; i < res.data.list.length; i++) {
                        this.courseList.push( {
                            id: res.data.list[i].id,
                            name: res.data.list[i].title
                        })
                        // set index in list
                        if (res.data.list[i].id == this.courseID) this.courseIndex = i
                    }
                })
                .catch(error => {
                        this.$store.commit('setFeedback', error)
                })                        
        },
        changeType() {
            this.chapter_type = this.types_list.indexOf(this.chapter_type_text)
        }
    },
    mounted() {
        this.needInit = true
    }      
     
}
</script>
